<template>
  <head>
    <meta charset="utf-8" />
    <title>Hotline Transporters Sacco | All invoices</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Rentings for Modern Market</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="housing-quick-stat.html">Housing</a></li>
                    <li class="breadcrumb-item"><a href="housing-register.html">Rentals Register</a></li>
                    <li class="breadcrumb-item active"><a href="#">Modern Market</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <ToolBarHousing/>

          <div class="row">
            <div class="col-12">
              <div class="card">

                <div class="card-header bg-white w-100 border-bottom d-flex justify-content-between align-items-center">
                  <h4 class="card-title text-uppercase">{{property.property}}</h4>
                  <div class="d-flex">
                    <!-- Reconcile All Units in Property Button -->
                    <button v-if="getRight('RECONCILE UNITS')"
                            @click="handleReconcileProperty"
                            type="button"
                            class="btn btn-outline-warning text-uppercase dropdown-toggle option-selector me-3"
                            :disabled="isReconciling">
                      <i class="bx bx-refresh font-size-16" :class="{ 'bx-spin': isReconciling }"></i>
                      <span class="pl-1 d-md-inline">{{ isReconciling ? 'Reconciling...' : 'Reconcile All' }}</span>
                    </button>

                    <button v-if="getRight('MONTHLY BILLING')"
                            @click="handleMonthlyBilling"
                            type="button"
                            class="btn btn-warning text-uppercase dropdown-toggle option-selector me-3">
                      <i class="bx bx-calculator font-size-16"></i>
                      <span class="pl-1 d-md-inline">Monthly Billing</span>
                    </button>
                    <a v-if="getRight('ADD UNIT')"
                       @click="handleAddUnit"
                       type="button"
                       class="btn btn-success text-uppercase dropdown-toggle option-selector me-3">
                      <i class="bx bx-plus font-size-16"></i>
                      <span class="pl-1 d-md-inline">Add Unit</span>
                    </a>
                  </div>
                </div>


                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control bg-light border-light rounded" placeholder="Search...">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div class="input-group fw-semibold text-uppercase me-3">
                        <label class="input-group-text text-uppercase">Unit type {{category}}</label>
                        <select class="form-select" v-model="category">
                          <option value="" selected="">All Unit Types (n)</option>
                          <option v-for="(item, index) in unitCategories" :key="`${index}`">
                            {{item.category}} ({{numberFormat(item.count)}})
                          </option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <div class="input-group fw-semibold text-uppercase me-3">
                        <label class="input-group-text text-uppercase">Unit Status</label>
                        <select class="form-select" v-model="unitStatus">
                          <option value="" selected="">All Units (n)</option>
                          <option v-for="(item, index) in unitStatuses" :key="`${index}`">
                            {{item.status}} ({{numberFormat(item.count)}})
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="d-flex">
                      <button @click="handleDownloadReport" type="button" class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="bx bxs-download font-size-16"></i>
                        <span class="pl-1 d-md-inline">{{download}}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive overflow-visible">
                    <table class="table align-middle table-hover contacts-table table-striped">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th>Stall No./Name</th>
                        <th>Stall Type</th>
                        <th scope="col">Tenant</th>
                        <th scope="col">Status</th>
                        <th>Last Payment Date</th>
                        <th>Account Status</th>
                        <th class="text-right">Monthly Rent</th>
                        <th class="text-right">Balance/Credit</th>
                        <th class="text-right">Amount Due</th>
                        <td></td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" v-for="(item, index) in units">
                        <th>{{item.unitNo}}</th>
                        <th>{{item.category}}</th>
                        <td><a href="javascript: void(0)">{{item.occupants}}</a></td>
                        <td>
                          {{item.status}}
                          <span v-if="!item.lastPaymentDate && !item.effectiveDate"
                                class="badge bg-warning ms-1"
                                title="Payment date not set">
                            <i class="mdi mdi-alert"></i>
                          </span>
                        </td>
                        <td>{{formatDate(item.lastPaymentDate)}}</td>
                        <td>
                          <span v-if="parseFloat(item.arrears) > 0" class="badge bg-danger">
                            <i class="mdi mdi-alert-circle me-1"></i>IN ARREARS
                          </span>
                          <span v-else-if="parseFloat(item.arrears) < 0" class="badge bg-success">
                            <i class="mdi mdi-check-circle me-1"></i>CREDIT BALANCE
                          </span>
                          <span v-else class="badge bg-info">
                            <i class="mdi mdi-check me-1"></i>UP TO DATE
                          </span>
                        </td>
                        <th class="table-info text-right text-black">{{numberFormat(item.monthlyRent)}}</th>
                        <th :class="getBalanceClass(item.arrears)" class="text-right text-black">
                          {{formatBalance(item.arrears)}}
                        </th>
                        <th :class="getTotalClass(item)" class="text-right text-black">
                          {{calculateAmountDue(item)}}
                        </th>
                        <td class="text-uppercase fw-bold text-right">

                          <div class="dropdown">
                            <button role="button" data-bs-toggle="dropdown" aria-haspopup="true"
                                    class="btn btn-sm btn-warning text-black waves-effect btn-label waves-light text-uppercase">
                              <i class="mdi mdi-arrow-down-drop-circle label-icon"></i> More Options
                            </button>
                            <div class="dropdown-menu dropdown-menu-end">
                              <a v-if="getRight('VACATE UNIT')"
                                 @click="handleVacateUnit(item)"
                                 class="dropdown-item"
                                 href="javascript: void(0)">
                                <i class="font-size-15 mdi mdi-eye-plus-outline me-3"></i>Vacate Unit
                              </a>
                              <a v-if="getRight('BILL CLIENT')"
                                 @click="handleBillClient(item)"
                                 class="dropdown-item"
                                 href="javascript: void(0)">
                                <i class="font-size-15 mdi mdi-receipt me-3"></i>Bill Client
                              </a>
                              <a v-if="getRight('RECORD PAYMENT')"
                                 @click="handleRecordPayment(item)"
                                 class="dropdown-item"
                                 href="javascript: void(0)">
                                <i class="font-size-15 mdi mdi-cash-plus me-3"></i>Record Payment
                              </a>
                              <a v-if="getRight('UPDATE PAYMENT DATE')"
                                 @click="handleUpdatePaymentDate(item)"
                                 class="dropdown-item"
                                 href="javascript: void(0)">
                                <i class="font-size-15 mdi mdi-calendar-clock me-3"></i>Update Payment Date
                              </a>
                              <a v-if="getRight('VIEW STATEMENTS')"
                                 @click="handleShowStatements(item)"
                                 class="dropdown-item"
                                 href="javascript: void(0)">
                                <i class="font-size-15 mdi mdi-microsoft-excel me-3"></i>Statements
                              </a>
                              <a v-if="getRight('EDIT HOUSE RENT')"
                                 @click="handleEditUnit(item)"
                                 class="dropdown-item"
                                 href="javascript: void(0)">
                                <i class="font-size-15 mdi mdi-file-document-edit me-3"></i>Edit
                              </a>
                              <div class="dropdown-divider"></div>
                              <a @click="handleReconcileUnit(item)"
                                 class="dropdown-item text-warning"
                                 href="javascript: void(0)">
                                <i class="font-size-15 mdi mdi-refresh me-3"></i>Reconcile Account
                              </a>
                            </div>
                          </div>

                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th colspan="1">{{numberFormat(units.length)}} Units</th>
                        <th colspan="4"></th>
                        <th></th>
                        <th class="text-right text-info text-uppercase">{{numberFormat(totalMonthyly)}}</th>
                        <th class="text-right text-uppercase" :class="totalArreas >= 0 ? 'text-danger' : 'text-success'">
                          {{formatBalance(totalArreas)}}
                        </th>
                        <th class="text-right text-uppercase" :class="totalAmountDue >= 0 ? 'text-danger' : 'text-success'">
                          {{numberFormat(Math.abs(totalAmountDue))}}
                        </th>
                        <th></th>
                      </tr>
                      </tfoot>
                    </table>

                    <div v-if="loading" class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center d-flex justify-content-center">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <div class="col-sm-12 col-md-8 col-lg-5">
                        <p>We are fetching the data for you. It will be ready soon. Please wait and have fun. Thank you for your interest.</p>
                      </div>
                    </div>

                    <div v-if="units.length<1 && loading === false" class="card-body d-sm-none d-md-block px-5 d-flex flex-column justify-items-center align-items-center text-center">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'./assets/images/no-results.png'" class="img mb-4" alt="No search results"/>
                      </div>
                      <h4>No Results To Show</h4>
                      <p>Sorry, we could not find any results that match your search or filter criteria. Please try using different keywords or filters.</p>
                    </div>
                  </div>
                </div>

                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation example" class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <span class="pr-3 pb-0 mb-0 font-13px">
                        <span>Rows Per Page</span>
                      </span>
                      <select class="form-select w-auto font-13px" v-model="pageSize">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                        <option value="150">150 Rows</option>
                        <option value="200">200 Rows</option>
                        <option value="5000">500 Rows</option>
                        <option value="10000">10000 Rows</option>
                        <option value="20000">20000 Rows</option>
                        <option value="10000000000">All Rows</option>
                      </select>
                    </div>

                    <ul class="pagination">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" tabindex="-1" @click="prevPage" :disabled="currentPage === 1">Previous</a>
                      </li>
                      <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page" class="page-item" :class="{ active: currentPage === page }">
                        <span v-if="page === '...'" class="page-link">{{ page }}</span>
                        <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Components -->
      <ReceiptingModal
          ref="downloadModal"
          :property="property"
          modal-id="download-modal"
      />

      <VacateUnitModal
          ref="vacateModal"
          :unit="selectedUnitData"
          @unit-vacated="onUnitVacated"
      />

      <BillClientModal
          ref="billModal"
          :unit="selectedUnitData"
          :income-types="billingModule.incomeTypes"
          @bill-generated="onBillGenerated"
      />

      <!-- Simplified Invoice Display Modal (No Payment) -->
      <InvoiceDisplayModal
          ref="invoiceModal"
          modal-id="invoice-display-modal"
      />

      <AddUnitModal
          ref="addUnitModal"
          :property="property"
          :unit-categories="unitCategories"
          modal-id="add-unit-modal"
          @unit-added="onUnitAdded"
      />

      <EditUnitModal
          ref="editModal"
          :unit="selectedUnitData"
          :unit-categories="unitCategories"
          modal-id="edit-unit-modal"
          @unit-updated="onUnitUpdated"
      />

      <StatementsModal
          ref="statementsModal"
          :unit="selectedUnitData"
          modal-id="statements-modal"
      />

      <UpdatePaymentDateModal
          ref="updateDateModal"
          :unit="selectedUnitData"
          modal-id="update-payment-date-modal"
          @date-updated="onDateUpdated"
      />

      <MonthlyBillingModal
          ref="monthlyBillingModal"
          modal-id="monthly-billing-modal"
          @billing-completed="onBillingCompleted"
      />

      <RecordPaymentModal
          ref="recordPaymentModal"
          :unit="selectedUnitData"
          modal-id="record-payment-modal"
          @payment-recorded="onPaymentRecorded"
      />

      <!-- Reconcile Unit Result Modal -->
      <div class="modal fade" id="reconcile-result-modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" :class="reconcileResult.changed ? 'bg-success' : 'bg-info'">
              <h5 class="modal-title text-white">
                <i class="bx bx-check-circle me-2"></i>Reconciliation Result
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="text-center mb-4">
                <i v-if="reconcileResult.changed" class="bx bx-check-circle text-success" style="font-size: 4rem;"></i>
                <i v-else class="bx bx-info-circle text-info" style="font-size: 4rem;"></i>
                <h5 class="mt-2">{{ reconcileResult.changed ? 'Account Updated!' : 'No Changes Needed' }}</h5>
                <p class="text-muted">Unit: {{ reconcileResult.unitNo }}</p>
              </div>

              <div class="table-responsive">
                <table class="table table-bordered mb-0">
                  <tbody>
                  <tr>
                    <th class="bg-light" style="width: 40%;">Unit</th>
                    <td>{{ reconcileResult.unitNo }} - {{ reconcileResult.occupants }}</td>
                  </tr>
                  <tr>
                    <th class="bg-light">Old Arrears</th>
                    <td :class="{ 'text-danger': reconcileResult.oldArrears > 0 }">
                      KES {{ numberFormat(reconcileResult.oldArrears) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="bg-light">New Arrears</th>
                    <td :class="{ 'text-danger': reconcileResult.newArrears > 0, 'text-success': reconcileResult.newArrears < reconcileResult.oldArrears }">
                      KES {{ numberFormat(reconcileResult.newArrears) }}
                      <span v-if="reconcileResult.newArrears < reconcileResult.oldArrears" class="badge bg-success ms-2">
                          <i class="bx bx-down-arrow-alt"></i> {{ numberFormat(reconcileResult.oldArrears - reconcileResult.newArrears) }}
                        </span>
                      <span v-else-if="reconcileResult.newArrears > reconcileResult.oldArrears" class="badge bg-danger ms-2">
                          <i class="bx bx-up-arrow-alt"></i> {{ numberFormat(reconcileResult.newArrears - reconcileResult.oldArrears) }}
                        </span>
                    </td>
                  </tr>
                  <tr>
                    <th class="bg-light">Old Credit</th>
                    <td :class="{ 'text-success': reconcileResult.oldCredit > 0 }">
                      KES {{ numberFormat(reconcileResult.oldCredit) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="bg-light">New Credit</th>
                    <td :class="{ 'text-success': reconcileResult.newCredit > 0 }">
                      KES {{ numberFormat(reconcileResult.newCredit) }}
                      <span v-if="reconcileResult.newCredit > reconcileResult.oldCredit" class="badge bg-success ms-2">
                          <i class="bx bx-up-arrow-alt"></i> {{ numberFormat(reconcileResult.newCredit - reconcileResult.oldCredit) }}
                        </span>
                    </td>
                  </tr>
                  <tr>
                    <th class="bg-light">Total Paid</th>
                    <td>KES {{ numberFormat(reconcileResult.totalPaid) }}</td>
                  </tr>
                  <tr>
                    <th class="bg-light">Unpaid Billed</th>
                    <td>KES {{ numberFormat(reconcileResult.unpaidBilled) }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="reconcileResult.changed" class="alert alert-success mt-3 mb-0">
                <i class="bx bx-check me-1"></i>
                The account has been successfully reconciled. The arrears and credit balance have been updated.
              </div>
              <div v-else class="alert alert-info mt-3 mb-0">
                <i class="bx bx-info-circle me-1"></i>
                The account is already balanced. No changes were necessary.
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Reconcile Property Progress Modal -->
      <div class="modal fade" id="reconcile-property-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-warning">
              <h5 class="modal-title">
                <i class="bx bx-refresh me-2" :class="{ 'bx-spin': !reconcilePropertyComplete }"></i>
                Reconciling {{ property.property }}
              </h5>
            </div>
            <div class="modal-body">
              <!-- Progress Section -->
              <div class="text-center mb-4">
                <div v-if="!reconcilePropertyComplete" class="spinner-border text-warning mb-3" style="width: 3rem; height: 3rem;" role="status">
                  <span class="visually-hidden">Processing...</span>
                </div>
                <div v-else class="mb-3">
                  <i class="bx bx-check-circle text-success" style="font-size: 3rem;"></i>
                </div>

                <h5 v-if="reconcilePropertyComplete" class="text-success">Reconciliation Complete!</h5>
                <h5 v-else>Processing units, please wait...</h5>
              </div>

              <!-- Progress Bar -->
              <div class="progress mb-3" style="height: 30px;">
                <div
                    class="progress-bar progress-bar-striped"
                    :class="{
                      'progress-bar-animated': !reconcilePropertyComplete,
                      'bg-warning': !reconcilePropertyComplete,
                      'bg-success': reconcilePropertyComplete
                    }"
                    role="progressbar"
                    :style="{ width: reconcilePropertyProgress.percentage + '%' }">
                  {{ reconcilePropertyProgress.percentage }}%
                </div>
              </div>

              <!-- Stats Row -->
              <div class="row text-center mb-4">
                <div class="col-3">
                  <div class="border rounded p-2">
                    <h4 class="mb-0 text-primary">{{ reconcilePropertyProgress.processed }}</h4>
                    <small class="text-muted">Processed</small>
                  </div>
                </div>
                <div class="col-3">
                  <div class="border rounded p-2">
                    <h4 class="mb-0 text-success">{{ reconcilePropertyProgress.changed }}</h4>
                    <small class="text-muted">Changed</small>
                  </div>
                </div>
                <div class="col-3">
                  <div class="border rounded p-2">
                    <h4 class="mb-0 text-info">{{ reconcilePropertyProgress.unchanged }}</h4>
                    <small class="text-muted">Unchanged</small>
                  </div>
                </div>
                <div class="col-3">
                  <div class="border rounded p-2">
                    <h4 class="mb-0 text-danger">{{ reconcilePropertyProgress.errors }}</h4>
                    <small class="text-muted">Errors</small>
                  </div>
                </div>
              </div>

              <!-- Current Unit Info -->
              <div v-if="!reconcilePropertyComplete && reconcilePropertyProgress.currentUnit" class="alert alert-light mb-3">
                <small>
                  <strong>Current:</strong> {{ reconcilePropertyProgress.currentUnit }}
                </small>
              </div>

              <!-- Results Table (shown when complete) -->
              <div v-if="reconcilePropertyComplete && reconcilePropertyResults.length > 0" class="mt-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="mb-0">Results ({{ reconcilePropertyResults.filter(r => r.changed).length }} changed)</h6>
                  <div class="btn-group btn-group-sm">
                    <button
                        class="btn btn-outline-secondary"
                        :class="{ active: showOnlyChangedProperty }"
                        @click="showOnlyChangedProperty = true">
                      Changed Only
                    </button>
                    <button
                        class="btn btn-outline-secondary"
                        :class="{ active: !showOnlyChangedProperty }"
                        @click="showOnlyChangedProperty = false">
                      All
                    </button>
                  </div>
                </div>

                <div class="table-responsive" style="max-height: 250px; overflow-y: auto;">
                  <table class="table table-sm table-striped table-bordered mb-0">
                    <thead class="table-dark sticky-top">
                    <tr>
                      <th>Unit</th>
                      <th class="text-end">Old Arrears</th>
                      <th class="text-end">New Arrears</th>
                      <th class="text-end">Old Credit</th>
                      <th class="text-end">New Credit</th>
                      <th class="text-center">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(result, idx) in filteredPropertyResults" :key="idx">
                      <td>{{ result.unitNo }}</td>
                      <td class="text-end" :class="{ 'text-danger': result.oldArrears > 0 }">
                        {{ numberFormat(result.oldArrears) }}
                      </td>
                      <td class="text-end" :class="{ 'text-danger': result.newArrears > 0, 'text-success': result.newArrears < result.oldArrears }">
                        {{ numberFormat(result.newArrears) }}
                      </td>
                      <td class="text-end" :class="{ 'text-success': result.oldCredit > 0 }">
                        {{ numberFormat(result.oldCredit) }}
                      </td>
                      <td class="text-end" :class="{ 'text-success': result.newCredit > 0 }">
                        {{ numberFormat(result.newCredit) }}
                      </td>
                      <td class="text-center">
                        <span v-if="result.changed" class="badge bg-success">Changed</span>
                        <span v-else class="badge bg-secondary">No Change</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <template v-if="reconcilePropertyComplete">
                <button class="btn btn-primary" @click="downloadPropertyReconcileReport()">
                  <i class="bx bx-download me-1"></i>Download Report
                </button>
                <button class="btn btn-secondary" @click="closeReconcilePropertyModal()">Close</button>
              </template>
              <template v-else>
                <button class="btn btn-danger" @click="cancelPropertyReconciliation()">
                  <i class="bx bx-x me-1"></i>Cancel
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">County Government</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import { biller, execute, executeDownload, getRight, rent } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import router from "@/router";
import ToolBarHousing from "@/components/housing/ToolBarHousing.vue";
import moment from "moment";

// Import all modal components
import VacateUnitModal from "@/components/housing/modals/VacateUnitModal.vue";
import BillClientModal from "@/components/housing/modals/BillClientModal.vue";
import InvoiceDisplayModal from "@/components/housing/modals/InvoiceDisplayModal.vue";
import AddUnitModal from "@/components/housing/modals/AddUnitModal.vue";
import EditUnitModal from "@/components/housing/modals/EditUnitModal.vue";
import ReceiptingModal from "@/components/housing/modals/ReceiptingModal.vue";
import StatementsModal from "@/components/housing/modals/StatementsModal.vue";
import UpdatePaymentDateModal from "@/components/housing/modals/UpdatePaymentDateModal.vue";
import MonthlyBillingModal from "@/components/housing/modals/MonthlyBillingModal.vue";
import RecordPaymentModal from "@/components/housing/modals/RecordPaymentModal.vue";

export default {
  name: "HousingDetails",
  components: {
    ToolBarHousing,
    NavigationBar,
    VacateUnitModal,
    BillClientModal,
    InvoiceDisplayModal,
    AddUnitModal,
    EditUnitModal,
    ReceiptingModal,
    StatementsModal,
    UpdatePaymentDateModal,
    MonthlyBillingModal,
    RecordPaymentModal
  },
  data() {
    return {
      selectedUnitData: {
        id: null,
        unitNo: '',
        category: '',
        monthlyRent: 0,
        arrears: 0,
        occupants: '',
        phoneNumber: '',
        idNo: '',
        property: '',
        status: '',
        lastPaymentDate: null,
        effectiveDate: null,
        zone: '',
        subCountyID: null,
        subCountyName: '',
        wardID: null,
        wardName: '',
        creditBalance: 0
      },
      search: '',
      download: 'Download Report',
      loading: true,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      summary: {
        count: 0,
        total: 0
      },
      category: '',
      unitStatus: '',
      unitCategories: [],
      totalMonthyly: 0,
      totalArreas: 0,
      totalAmountDue: 0,
      units: [],
      unitStatuses: [],
      property: {
        id: null,
        propertyID: null,
        property: null,
        subCountyName: null,
        subCountyID: null,
        wardName: null,
        wardID: null,
        zone: null
      },
      billingModule: {
        incomeTypes: []
      },

      // Reconcile single unit
      isReconcilingUnit: false,
      reconcileResult: {
        unitNo: '',
        occupants: '',
        oldArrears: 0,
        newArrears: 0,
        oldCredit: 0,
        newCredit: 0,
        totalPaid: 0,
        unpaidBilled: 0,
        changed: false
      },

      // Reconcile property (all units)
      isReconciling: false,
      reconcilePropertyComplete: false,
      reconcilePropertyCancelled: false,
      showOnlyChangedProperty: true,
      reconcilePropertyProgress: {
        processed: 0,
        total: 0,
        percentage: 0,
        changed: 0,
        unchanged: 0,
        errors: 0,
        currentUnit: ''
      },
      reconcilePropertyResults: []
    }
  },

  computed: {
    filteredPropertyResults() {
      if (this.showOnlyChangedProperty) {
        return this.reconcilePropertyResults.filter(r => r.changed);
      }
      return this.reconcilePropertyResults;
    }
  },

  watch: {
    pageSize(newPageSize) {
      this.getUnits();
      const totalItems = this.summary.count;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },
    category() {
      this.getUnits();
    },
    unitStatus() {
      this.getUnits();
    },
    search() {
      this.getUnits();
    }
  },
  mounted() {
    this.getProperty();
    this.getUnits();
    this.getUnitStatus();
    this.getUnitCategories();
    this.getIncomeTypes();
    this.menuAccess();
  },
  methods: {
    getRight,

    // NEW METHODS FOR PROPER BALANCE DISPLAY
    formatBalance(arrears) {
      const amount = parseFloat(arrears);
      if (amount < 0) {
        return `(${this.numberFormat(Math.abs(amount))}) CR`;
      } else if (amount > 0) {
        return this.numberFormat(amount);
      }
      return '0';
    },

    getBalanceClass(arrears) {
      const amount = parseFloat(arrears);
      if (amount < 0) {
        return 'table-success';
      } else if (amount > 0) {
        return 'table-danger';
      }
      return 'table-info';
    },

    calculateAmountDue(item) {
      const arrears = parseFloat(item.arrears);
      if (arrears < 0) {
        return '0';
      } else {
        return this.numberFormat(arrears);
      }
    },

    getTotalClass(item) {
      const arrears = parseFloat(item.arrears);
      if (arrears < 0) {
        return 'table-success';
      } else if (arrears > 0) {
        return 'table-danger';
      }
      return 'table-info';
    },

    // ==================== RECONCILE SINGLE UNIT ====================
    handleReconcileUnit(item) {
      if (!confirm(`Are you sure you want to reconcile the account for ${item.unitNo} (${item.occupants})?`)) {
        return;
      }

      this.isReconcilingUnit = true;

      const data = new FormData();
      data.append("function", "reconcileUnit");
      data.append("unitId", item.id);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      // Store old values
      const oldArrears = parseFloat(item.arrears) || 0;
      const oldCredit = parseFloat(item.creditBalance) || 0;

      execute(data, rent)
          .then((res) => {
            this.isReconcilingUnit = false;

            if (res.data.success) {
              this.reconcileResult = {
                unitNo: res.data.data.unitNo || item.unitNo,
                occupants: res.data.data.occupants || item.occupants,
                oldArrears: oldArrears,
                newArrears: res.data.data.newArrears || 0,
                oldCredit: oldCredit,
                newCredit: res.data.data.newCredit || 0,
                totalPaid: res.data.data.totalPaid || 0,
                unpaidBilled: res.data.data.unpaidBilled || 0,
                changed: res.data.data.changed || false
              };

              // Show result modal
              const modal = new window.bootstrap.Modal(document.getElementById('reconcile-result-modal'));
              modal.show();

              // Refresh units list
              this.getUnits();
            } else {
              alert('Reconciliation failed: ' + res.data.message);
            }
          })
          .catch((error) => {
            this.isReconcilingUnit = false;
            alert('Error reconciling unit: ' + error.message);
          });
    },

    // ==================== RECONCILE ALL UNITS IN PROPERTY ====================
    async handleReconcileProperty() {
      if (!confirm(`Are you sure you want to reconcile all units in ${this.property.property}? This will recalculate arrears and credit balances for all units.`)) {
        return;
      }

      // Reset state
      this.isReconciling = true;
      this.reconcilePropertyComplete = false;
      this.reconcilePropertyCancelled = false;
      this.reconcilePropertyResults = [];
      this.reconcilePropertyProgress = {
        processed: 0,
        total: this.units.length,
        percentage: 0,
        changed: 0,
        unchanged: 0,
        errors: 0,
        currentUnit: ''
      };

      // Show progress modal
      const modal = new window.bootstrap.Modal(document.getElementById('reconcile-property-modal'));
      modal.show();

      // First, fetch ALL units for this property (not just current page)
      const allUnits = await this.fetchAllUnitsForProperty();
      this.reconcilePropertyProgress.total = allUnits.length;

      // Process each unit
      for (let i = 0; i < allUnits.length; i++) {
        if (this.reconcilePropertyCancelled) {
          break;
        }

        const unit = allUnits[i];
        this.reconcilePropertyProgress.currentUnit = `${unit.unitNo} - ${unit.occupants}`;

        try {
          const result = await this.reconcileUnitAsync(unit);

          if (result) {
            const changed = result.oldArrears !== result.newArrears ||
                result.oldCredit !== result.newCredit;

            this.reconcilePropertyResults.push({
              unitId: unit.id,
              unitNo: unit.unitNo,
              occupants: unit.occupants,
              oldArrears: result.oldArrears,
              newArrears: result.newArrears,
              oldCredit: result.oldCredit,
              newCredit: result.newCredit,
              changed: changed
            });

            if (changed) {
              this.reconcilePropertyProgress.changed++;
            } else {
              this.reconcilePropertyProgress.unchanged++;
            }
          }
        } catch (error) {
          console.error('Error reconciling unit:', unit.id, error);
          this.reconcilePropertyProgress.errors++;

          this.reconcilePropertyResults.push({
            unitId: unit.id,
            unitNo: unit.unitNo,
            occupants: unit.occupants,
            oldArrears: parseFloat(unit.arrears) || 0,
            newArrears: parseFloat(unit.arrears) || 0,
            oldCredit: parseFloat(unit.creditBalance) || 0,
            newCredit: parseFloat(unit.creditBalance) || 0,
            changed: false,
            error: true
          });
        }

        this.reconcilePropertyProgress.processed++;
        this.reconcilePropertyProgress.percentage = Math.round(((i + 1) / allUnits.length) * 100);

        // Small delay to prevent overwhelming the server
        await this.delay(100);
      }

      // Complete
      this.reconcilePropertyComplete = true;
      this.isReconciling = false;

      // Refresh units list
      this.getUnits();
    },

    async fetchAllUnitsForProperty() {
      return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append("function", "getUnits");
        data.append("propertyID", sessionStorage.getItem("propertyID"));
        data.append("page", 1);
        data.append("rows_per_page", 100000); // Get all

        execute(data, rent)
            .then((res) => {
              if (res.data.success) {
                resolve(res.data.data.units || []);
              } else {
                resolve([]);
              }
            })
            .catch((error) => {
              reject(error);
            });
      });
    },

    reconcileUnitAsync(unit) {
      return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append("function", "reconcileUnit");
        data.append("unitId", unit.id);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        const oldArrears = parseFloat(unit.arrears) || 0;
        const oldCredit = parseFloat(unit.creditBalance) || 0;

        execute(data, rent)
            .then((res) => {
              if (res.data.success) {
                resolve({
                  oldArrears: oldArrears,
                  newArrears: res.data.data.newArrears || 0,
                  oldCredit: oldCredit,
                  newCredit: res.data.data.newCredit || 0
                });
              } else {
                reject(new Error(res.data.message || 'Reconciliation failed'));
              }
            })
            .catch((error) => {
              reject(error);
            });
      });
    },

    cancelPropertyReconciliation() {
      if (confirm('Are you sure you want to cancel? Progress will be saved.')) {
        this.reconcilePropertyCancelled = true;
        this.reconcilePropertyComplete = true;
      }
    },

    closeReconcilePropertyModal() {
      const modalElement = document.getElementById('reconcile-property-modal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      // Clean up
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    },

    downloadPropertyReconcileReport() {
      if (this.reconcilePropertyResults.length === 0) {
        alert('No results to download');
        return;
      }

      // Generate CSV
      const headers = [
        'NO.',
        'Unit No',
        'Occupant',
        'Old Arrears',
        'New Arrears',
        'Arrears Change',
        'Old Credit',
        'New Credit',
        'Credit Change',
        'Status'
      ];

      let csv = headers.join(',') + '\n';

      this.reconcilePropertyResults.forEach((result, index) => {
        const arrearsChange = result.newArrears - result.oldArrears;
        const creditChange = result.newCredit - result.oldCredit;

        const row = [
          index + 1,
          this.escapeCSV(result.unitNo),
          this.escapeCSV(result.occupants || ''),
          result.oldArrears,
          result.newArrears,
          arrearsChange,
          result.oldCredit,
          result.newCredit,
          creditChange,
          result.changed ? 'CHANGED' : 'NO CHANGE'
        ];
        csv += row.join(',') + '\n';
      });

      // Add summary
      csv += '\n';
      csv += 'RECONCILIATION SUMMARY\n';
      csv += `Property,${this.property.property}\n`;
      csv += `Date,${moment().format('DD/MM/YYYY HH:mm:ss')}\n`;
      csv += `Total Units Processed,${this.reconcilePropertyProgress.processed}\n`;
      csv += `Units Changed,${this.reconcilePropertyProgress.changed}\n`;
      csv += `Units Unchanged,${this.reconcilePropertyProgress.unchanged}\n`;
      csv += `Errors,${this.reconcilePropertyProgress.errors}\n`;
      csv += '\n';

      // Calculate totals
      const totalOldArrears = this.reconcilePropertyResults.reduce((sum, r) => sum + r.oldArrears, 0);
      const totalNewArrears = this.reconcilePropertyResults.reduce((sum, r) => sum + r.newArrears, 0);
      const totalOldCredit = this.reconcilePropertyResults.reduce((sum, r) => sum + r.oldCredit, 0);
      const totalNewCredit = this.reconcilePropertyResults.reduce((sum, r) => sum + r.newCredit, 0);

      csv += 'FINANCIAL SUMMARY\n';
      csv += `Total Old Arrears,${totalOldArrears}\n`;
      csv += `Total New Arrears,${totalNewArrears}\n`;
      csv += `Arrears Difference,${totalNewArrears - totalOldArrears}\n`;
      csv += `Total Old Credit,${totalOldCredit}\n`;
      csv += `Total New Credit,${totalNewCredit}\n`;
      csv += `Credit Difference,${totalNewCredit - totalOldCredit}\n`;

      // Download
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `Reconciliation_${this.property.property}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // Modal handlers
    handleAddUnit() {
      this.$nextTick(() => {
        const modal = new window.bootstrap.Modal(document.getElementById('add-unit-modal'));
        modal.show();
      });
    },

    handleVacateUnit(item) {
      this.selectedUnitData = Object.assign({}, item);
      this.$nextTick(() => {
        this.$refs.vacateModal.show();
      });
    },

    handleBillClient(item) {
      this.selectedUnitData = Object.assign({}, item);
      this.$nextTick(() => {
        this.$refs.billModal.show();
      });
    },

    handleRecordPayment(item) {
      this.selectedUnitData = Object.assign({}, item);
      this.$nextTick(() => {
        const modal = new window.bootstrap.Modal(document.getElementById('record-payment-modal'));
        modal.show();
      });
    },

    handleMonthlyBilling() {
      this.$nextTick(() => {
        const modal = new window.bootstrap.Modal(document.getElementById('monthly-billing-modal'));
        modal.show();
        if (this.$refs.monthlyBillingModal) {
          this.$refs.monthlyBillingModal.loadBillingHistory();
        }
      });
    },

    handleUpdatePaymentDate(item) {
      this.selectedUnitData = Object.assign({}, item);
      this.$nextTick(() => {
        const modal = new window.bootstrap.Modal(document.getElementById('update-payment-date-modal'));
        modal.show();
        if (this.$refs.updateDateModal) {
          this.$refs.updateDateModal.show();
        }
      });
    },

    handleShowStatements(item) {
      this.selectedUnitData = Object.assign({}, item);
      this.$nextTick(() => {
        const modalElement = document.getElementById('statements-modal');
        if (modalElement) {
          const modal = new window.bootstrap.Modal(modalElement);
          modal.show();
          setTimeout(() => {
            this.$refs.statementsModal.show();
          }, 100);
        }
      });
    },

    handleEditUnit(item) {
      this.selectedUnitData = Object.assign({}, item);
      this.$nextTick(() => {
        const modal = new window.bootstrap.Modal(document.getElementById('edit-unit-modal'));
        modal.show();
      });
    },

    handleDownloadReport() {
      this.downloadUnits();
    },

    // Event handlers from modals
    onBillGenerated(responseData) {
      console.log('Bill generated response:', responseData);
      this.getUnits();

      this.$nextTick(() => {
        if (this.$refs.invoiceModal) {
          this.$refs.invoiceModal.initializeWithBillData({
            billDetails: responseData.bill.billDetails,
            billInfo: responseData.bill.billInfo,
            billGenerated: responseData.billGenerated,
            unit: this.selectedUnitData
          });

          setTimeout(() => {
            const modal = new window.bootstrap.Modal(document.getElementById('invoice-display-modal'));
            modal.show();
          }, 200);
        }
      });
    },

    onUnitVacated() {
      this.getUnits();
    },

    onUnitAdded() {
      this.getUnits();
      this.getUnitCategories();
    },

    onUnitUpdated() {
      this.getUnits();
    },

    onDateUpdated(data) {
      this.getUnits();
      alert(`Payment date updated successfully for unit ${data.unitID}`);
    },

    onBillingCompleted(data) {
      this.getUnits();
      alert(`Billing completed: ${data.unitsBilled} units billed for KES ${this.numberFormat(data.totalBilled)}`);
    },

    onPaymentRecorded(data) {
      this.getUnits();
      alert(`Payment recorded successfully. Receipt No: ${data.receiptNo}`);
    },

    // API Methods
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Housing Details");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {})
          .catch(() => {});
    },

    getProperty() {
      const data = new FormData();
      data.append("function", "getProperty");
      data.append("propertyID", sessionStorage.getItem("propertyID"));
      execute(data, rent)
          .then((res) => {
            if (res.data.success) {
              this.property = res.data.data.property;
            }
          })
          .catch(() => {});
    },

    getUnitCategories() {
      const data = new FormData();
      data.append("function", "getUnitCategory");
      execute(data, rent)
          .then((res) => {
            if (res.data.success) {
              this.unitCategories = res.data.data.unitCategories || [];
            }
          })
          .catch(() => {});
    },

    getUnitStatus() {
      this.unitStatuses.splice(0);
      const data = new FormData();
      data.append("function", "getUnitStatus");
      execute(data, rent)
          .then((res) => {
            if (res.data.success) {
              this.unitStatuses = res.data.data.unitStatuses;
            }
          })
          .catch(() => {});
    },

    getIncomeTypes() {
      this.billingModule.incomeTypes.splice(0);
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "HSRENT");
      data.append("keyword", "Housing");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.billingModule.incomeTypes = res.data.data.incomeTypes;
            }
          })
          .catch(() => {});
    },

    getUnits() {
      this.loading = true;
      this.units.splice(0);

      let str = this.category;
      let cleanedStr = str.replace(/\(\d+\)/, '').trim();

      let str2 = this.unitStatus;
      let cleanedStr2 = str2.replace(/\(\d+\)/, '').trim();

      const data = new FormData();
      data.append("function", "getUnits");
      data.append("propertyID", sessionStorage.getItem("propertyID"));
      data.append("category", cleanedStr);
      data.append("unitStatus", cleanedStr2);
      data.append("keyword", this.search);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);

      execute(data, rent)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.units = res.data.data.units;

              this.totalMonthyly = this.units.reduce((acc, cur) => {
                let receiptAmount = Number(cur.monthlyRent);
                return acc + receiptAmount;
              }, 0);

              this.totalArreas = this.units.reduce((acc, cur) => {
                let receiptAmount = Number(cur.arrears);
                return acc + receiptAmount;
              }, 0);

              this.totalAmountDue = this.units.reduce((acc, cur) => {
                let arrears = Number(cur.arrears);
                if (arrears > 0) {
                  return acc + arrears;
                }
                return acc;
              }, 0);

              this.summary.count = res.data.data.summary.count;
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
            }
          })
          .catch(() => {
            this.loading = false;
          });
    },

    downloadUnits() {
      this.download = "Please wait..";

      let str = this.category;
      let cleanedStr = str.replace(/\(\d+\)/, '').trim();

      let str2 = this.unitStatus;
      let cleanedStr2 = str2.replace(/\(\d+\)/, '').trim();

      const data = new FormData();
      data.append("function", "downloadUnits");
      data.append("propertyID", sessionStorage.getItem("propertyID"));
      data.append("category", cleanedStr);
      data.append("unitStatus", cleanedStr2);

      executeDownload(data, rent).then(response => {
        this.download = "Download Report";
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = "Report.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(() => {
        this.download = "Download Report";
      });
    },

    // Utility methods
    sumNumbers(a, b) {
      if (typeof a === 'string') {
        a = parseFloat(a);
      }
      if (typeof b === 'string') {
        b = parseFloat(b);
      }

      if (isNaN(a) || isNaN(b)) {
        return "0";
      }

      return a + b;
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0);
    },

    formatDate(dateStr) {
      if (!dateStr) return "Invalid Date";

      const date = new Date(dateStr);

      if (isNaN(date.getTime())) return "Invalid Date";

      const options = {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      };

      const formattedDate = date.toLocaleDateString('en-US', options);
      const formattedTime = date.toLocaleTimeString('en-US', options);

      return formattedDate.replace(',', '') + ' ' + formattedTime;
    },

    // Pagination methods
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getUnits();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getUnits();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getUnits();
      }
    },

    gotTo(route) {
      router.push(route);
    }
  }
}
</script>

<style scoped>
.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>